// Story 7.33 (ADO-2026): the phone's "Planogram" button beside the catalogue listing's Filters
// button (Figma "Planogram button", 7054:165739), where the header has no room for the entry.
// Inside a plan the breadcrumb's Planogram crumb takes its place (Epic 7 3 amigos follow-ups,
// 2026-11-03), so only the catalogue shows it.
import { NavLink } from 'react-router';
import { Icon } from '../../design-system';
import { PLANOGRAMS_ROUTE } from '../../planogram/usePlanogramAvailability';
import styles from './Planograms.module.css';

export function PlanogramChip() {
  return (
    <NavLink to={PLANOGRAMS_ROUTE} className={styles.chip ?? ''}>
      <Icon name="rows" size={12} />
      Planogram
    </NavLink>
  );
}
